import React, { useState, useRef, useEffect } from 'react';

const countryOptions = [
  { code: '+31', label: 'Nederland', flag: '🇳🇱', placeholder: '612345678' },
  { code: '+32', label: 'België', flag: '🇧🇪', placeholder: '471234567' },
  // { code: '+49', label: 'Germany', flag: '🇩🇪', placeholder: '15123456789' },
  // { code: '+44', label: 'United Kingdom', flag: '🇬🇧', placeholder: '7123456789' },
  // { code: '+33', label: 'France', flag: '🇫🇷', placeholder: '612345678' },
  // { code: '+34', label: 'Spain', flag: '🇪🇸', placeholder: '612345678' },
  // { code: '+1', label: 'United States', flag: '🇺🇸', placeholder: '2012345678' },
];

interface PhoneInputProps {
  countryCode: string;
  setCountryCode: (code: string) => void;
  phone: string;
  setPhone: (val: string) => void;
  required?: boolean;
  label?: string;
  error?: string | null;
}

const PhoneInput: React.FC<PhoneInputProps> = ({ countryCode, setCountryCode, phone, setPhone, required, label, error }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const selected = countryOptions.find(opt => opt.code === countryCode) || countryOptions[0];

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div>
      {label && <label className="block mb-1 text-sm font-medium text-neutral-700">{label}</label>}
      <div className="flex relative" ref={dropdownRef}>
        <button
          type="button"
          className={`flex items-center gap-2 px-3 py-2 bg-neutral-50 border border-neutral-300 rounded-l-lg text-sm font-medium focus:ring-2 focus:ring-homeme focus:z-10 ${open ? 'ring-2 ring-homeme' : ''}`}
          onClick={() => setOpen(v => !v)}
          tabIndex={0}
        >
          <span className="text-lg">{selected.flag}</span>
          {/* <span className="hidden sm:inline">{selected.label}</span> */}
          <span className="font-mono">{selected.code}</span>
          <svg className={`w-4 h-4 ml-1 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        {open && (
          <div className="absolute left-0 top-12 z-50 w-64 bg-white border border-neutral-200 rounded-lg shadow-lg max-h-72 overflow-auto animate-fade-in">
            {countryOptions.map(opt => (
              <button
                key={opt.code}
                type="button"
                className={`flex items-center w-full px-4 py-2 text-sm hover:bg-neutral-100 ${opt.code === countryCode ? 'bg-neutral-100 font-semibold' : ''}`}
                onClick={() => { setCountryCode(opt.code); setOpen(false); }}
              >
                <span className="text-lg mr-2">{opt.flag}</span>
                <span className="flex-1 text-left">{opt.label}</span>
                <span className="font-mono">{opt.code}</span>
              </button>
            ))}
          </div>
        )}
        <input
          type="tel"
          className={`rounded-r-lg border border-l-0 border-neutral-300 bg-white px-3 py-2 text-sm w-full focus:ring-homeme focus:border-homeme outline-none ${error ? 'border-red-400' : ''}`}
          placeholder={selected.placeholder}
          value={phone}
          onChange={e => setPhone(e.target.value.replace(/\D/g, ''))}
          required={required}
          style={{ minWidth: 0 }}
        />
      </div>
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
};

export default PhoneInput; 